<template>
  <b-card>
    <!-- TABLE -->

    <b-table
      show-empty
      sticky-header
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template slot="bottom-row" slot-scope="data">
        <td align="right" :span="data.columns" colspan="4">
          <b>Grand Total (RM)</b>
        </td>
        <td :span="data.columns">{{ grandp }}</td>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    grandp: {
      type: [String, Number]
    }
  },
  // computed: {
  //   total: function() {
  //     return this.rows.reduce(function(total, totalPrice) {
  //       return total + totalPrice;
  //     }, 0);
  //   }
  // },
  methods: {}
};
</script>
<style lang="css" scoped></style>
